"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CollectionFormCtrl = void 0;
const core_api_1 = require("@ikegps/core-api");
const i18n_1 = require("../../i18n");
const index_1 = require("../../services/index");
const page_state_1 = require("../../state/page.state");
const collection_form_modal_1 = require("../collection.form.modal/collection.form.modal");
exports.CollectionFormCtrl = {
    canDisplay() {
        return index_1.Services.Token.has(core_api_1.IkeToken.FEATURE_GROUP_IKE_ANALYZE);
    },
    showUpdateFormModal() {
        const collections = page_state_1.CurrentState.Tag.collections;
        const modal = new collection_form_modal_1.CollectionFormModal({
            title: i18n_1.T.COLLECTION_UPDATE_FORM_TITLE,
            confirm: i18n_1.T.COLLECTION_UPDATE_FORM,
            success: {
                key: i18n_1.T.COLLECTION_UPDATE_FORM_SUCCESS
            }
        }, collections);
        modal.open();
    }
};
//# sourceMappingURL=collection.form.ctrl.js.map